import React, { Component, Fragment } from 'react';
import { Button } from 'react-bootstrap';
import { Loader } from '../../../../components/Loader';
import {Grid} from 'jrgrid';
import { columns, filterButtons } from '../utils';
import { pageUnassignedAssets } from '../api';

class UnassignedAssetsGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterIndex: filterButtons.length - 1,
      filter: null,
      refresh: this.props.refresh, //false,
      selectedOwner: this.props.selectedOwner,
    };
  }

  // In parent component user may select owner, need to re-render grid
  componentWillReceiveProps(newProps) {
    this.setState({ selectedOwner: newProps.selectedOwner, refresh: newProps.refresh });
  }

  setFilterIndex = (filterIndex, filter) => {
    this.setState({
      filterIndex,
      filter,
      refresh: true,
    });
  };

  renderGrid() {
    if (this.state.refresh) {
      setTimeout(() => {
        this.setState({
          refresh: false,
        });
      }, 500);
      return <Loader title="Reloading Grid.." />;
    } else {
      let filter = [];

      if (this.state.selectedOwner) {
        filter.push({
          id: 'Owner',
          type: 'string',
          operand: 'and',
          isLike: false,
          value: this.state.selectedOwner,
        });
      }

      filter.push({
        id: 'Source',
        type: 'string',
        operand: 'and',
        isLike: false,
        value: 'Non-Capital',
      });

      // filter.push({
      //   id: 'Year',
      //   type: 'string',
      //   operand: 'and',
      //   isLike: false,
      //   value: new Date().getFullYear(),
      // });

      return (
        <Grid
          amount={20}
          columns={columns}
          query={pageUnassignedAssets}
          queryName="pageUnassignedAssets"
          defaultSortField="AssetID"
          globalFilters={this.state.filter ? [this.state.filter, ...filter] : [...filter]}
        />
      );
    }
  }

  render() {
    return (
      <Fragment>
        <div className="container-fluid">
          <div className="row">
            {filterButtons.map((item, index) => {
              return (
                <Button
                  key={index}
                  className="mt-3 mb-3 ml-2"
                  onClick={() => this.setFilterIndex(index, item.filter)}
                  variant={this.state.filterIndex === index ? item.variant : `outline-${item.variant}`}
                >
                  {item.title}
                </Button>
              );
            })}
          </div>
          <div className="ml-5 mr-5">{this.renderGrid()}</div>
        </div>
      </Fragment>
    );
  }
}

export default UnassignedAssetsGrid;
